import { render, staticRenderFns } from "./addSecurity.vue?vue&type=template&id=983a3ea0&scoped=true&"
import script from "./addSecurity.vue?vue&type=script&lang=js&"
export * from "./addSecurity.vue?vue&type=script&lang=js&"
import style0 from "./addSecurity.vue?vue&type=style&index=0&id=983a3ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983a3ea0",
  null
  
)

export default component.exports